import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconVkStyle0 = gravityIconIndividualCss;

const GravityIconVk = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '7cc8472530615fe5d2371527a38cc37041279f19', color: this.color, size: this.size }, h("svg", { key: '46497d988f453bb8213357cd7fdda4f01aac7f3c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '704cb30a3b919a007e9755119fd2a35ad80efaa8', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.5 8.7v4.6c0 4.2-1 5.2-5.2 5.2H8.7c-4.2 0-5.2-1-5.2-5.2V8.7c0-4.2 1-5.2 5.2-5.2h4.6c4.2 0 5.2 1 5.2 5.2Zm-2.89 5.5c.32 0 .47-.15.38-.46a4.681 4.681 0 0 0-.92-1.28c-.25-.3-.64-.63-.75-.79-.11-.16-.12-.3 0-.49a14.002 14.002 0 0 0 1.47-2.51c.07-.23 0-.4-.33-.4h-1.1a.47.47 0 0 0-.47.3 9.171 9.171 0 0 1-1.35 2.24c-.25.26-.37.34-.5.34s-.18-.08-.18-.32V8.67c0-.28-.08-.4-.31-.4H9.83a.25.25 0 0 0-.27.25c0 .26.39.32.43 1.06v1.61c0 .36-.06.42-.2.42-.37 0-1.28-1.36-1.81-2.92-.11-.3-.21-.42-.49-.42H6.4c-.32 0-.38.14-.38.3a8.75 8.75 0 0 0 1.73 3.63 4.24 4.24 0 0 0 3.33 2c.7 0 .78-.15.78-.42v-1c0-.32.07-.38.29-.38.22 0 .44.08 1.09.71.65.63.86 1.07 1.28 1.07l1.09.02Z", fill: "currentColor" }))));
    }
};
GravityIconVk.style = GravityIconVkStyle0;

export { GravityIconVk as gravity_icon_vk };

//# sourceMappingURL=gravity-icon-vk.entry.js.map